// import { Fancybox } from "@fancyapps/ui";
import { gsap, Sine, Power0, Power1, Power2, Power3, Power4 } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import SVGInject from "@iconfu/svg-inject";
import TomSelect from 'tom-select';
import ScrollHint from 'scroll-hint'
import { initModal } from "./modules/ui/modal/index.js";

gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(ScrollTrigger);

// import { openImgModal } from "./modules/ui/modalImg.js";

// matchMedia
// =======================================================
// const mediaQuery_lg = window.matchMedia("(min-width: 1100px)");
// const mediaQuery_xl = window.matchMedia("(min-width: 1300px)");
// const mediaQuery_md = window.matchMedia("(min-width: 768px)");

// FUNCTION
// =======================================================
function isInPage(node) {
  return (node === document.body) ? false : document.body.contains(node);
}

function closest(node, selector) {
  // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
  return (
    node.closest ||
    function (_selector) {
      do {
        // nodeとselectorがマッチしたら返す
        if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
          return node;
        }
        // マッチしなかったら親要素を代入
        node = node.parentElement || node.parentNode;
      } while (node !== null && node.nodeType === 1);
      return null;
    }
  ).call(node, selector);
}

// SVG SPRITE
// =======================================================

document.querySelectorAll('[data-inject]').forEach(img => {
  SVGInject(img);
});


// モーダル
// =======================================================

initModal();

// コーチの高さを揃える
// =======================================================
// equalizeCoachCardHeights();

// const modalTriggers = document.querySelectorAll("[data-modal]");
// modalTriggers.forEach( trigger => {

//   trigger.addEventListener("click", (e) => {
//     e.preventDefault(); // <a>の場合のデフォルト遷移を無効化

//     const type = trigger.dataset.modal;

//     if( type == "img" ) {
//       const imgSrc = trigger.getAttribute("href");
//       openImgModal({
//         imgSrc: imgSrc,
//         imgAlt: trigger.dataset.alt || "",
//       });
//     }
//   });
// });


// SVG インライン
// =======================================================


// SVGファイルのパスを配列に格納
const protocol = window.location.protocol; // 'http:' または 'https:'
const host = window.location.host; // 例: 'example.com'
const templatePath = `${protocol}//${host}/assets/img/sprite.svg`;
const svgFilePaths = [
  templatePath, // 1つ目のSVGファイル
];

// svg-containerを作成
const svgContainer = document.createElement('div');
svgContainer.style.display = "none";
svgContainer.id = 'svg-sprite';
document.body.appendChild(svgContainer); // ボディに追加

// Fetch APIを使ってSVGを読み込む関数
const loadSVG = (svgFilePath) => {
  return fetch(svgFilePath)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.text();
  })
  .then(svgContent => {
    svgContainer.innerHTML += svgContent; // SVGコンテンツを追加
  })
  .catch(error => {
    console.error('Error loading SVG:', error);
  });
};

// すべてのSVGファイルを読み込む
Promise.all(svgFilePaths.map(loadSVG))
  .then(() => {
    console.log('All SVGs loaded successfully');
  })
  .catch(error => {
    console.error('Error loading one or more SVGs:', error);
  });


// DRAWER
// =======================================================
const menuBtn = document.querySelector('.l-drawer__btn');

if ( menuBtn ) {
  const drawer = document.querySelector(".l-drawer");
  const drawerLinks = drawer.querySelector(".l-header__links");
  const drawerOther = drawer.querySelector(".l-header__other");

  const timelines = {
    open: gsap.timeline({ paused: true })
      .set(drawer, { display: 'block'})
      .to(drawer, { autoAlpha: 1, duration: 0.2, ease: 'power2.out' })
      .to([drawerLinks, drawerOther], { autoAlpha: 1, y: "0%", stagger: 0.2, duration: 0.4 }),
  
    close: gsap.timeline({ paused: true })
      .to([drawerLinks, drawerOther], { autoAlpha: 0, duration: 0.4, ease: 'power2.in' })
      .to(drawer, {autoAlpha: 0, duration: 0.2, ease: 'power2.out' })
      .set([drawerLinks, drawerOther], { y: "10%" })
      .set(drawer, {display: 'none' }),
  };

  // ボタンのクリックイベントを設定
  menuBtn.addEventListener('click', () => {
    if (drawer.style.display === 'block') {
      menuBtn.classList.remove("is-open");
      timelines.close.restart(); // 開いている場合は閉じる
    } else {
      menuBtn.classList.add("is-open");
      timelines.open.restart(); // 閉じている場合は開く
    }
  });
}

// SCORLL TABLE
// =======================================================

window.addEventListener('DOMContentLoaded', function(){
  new ScrollHint('[data-scroll-table]');
});


// SMOOTH SCROLL
// =======================================================

// ページ内リンクのイベントリスナーを設定
gsap.utils.toArray('a[href*="#"]').forEach(function (anchor) {
  anchor.addEventListener("click", function (event) {
    const href = anchor.getAttribute("href"); // クリックしたリンクのhref属性を取得
    const targetId = href.includes("#") ? href.split("#")[1] : null; // ハッシュタグ部分を取得

    if (targetId) {
      const targetElement = document.getElementById(targetId); // ターゲット要素を取得

      if (targetElement) {
        event.preventDefault(); // デフォルトのリンク動作をキャンセル

        // スムーススクロールを実行
        smoothScrollTo(targetElement);
      }
    }
  });
});

// ページロード時にハッシュタグをチェック
window.addEventListener("load", function () {
  const hash = window.location.hash; // 現在のURLのハッシュ部分を取得
  if (hash) {
    const targetId = hash.replace("#", ""); // ハッシュ記号を削除してIDを取得
    const targetElement = document.getElementById(targetId); // ターゲット要素を取得

    if (targetElement) {
      // スムーススクロールを実行
      smoothScrollTo(targetElement);
    }
  }
});

// スムーススクロール関数
function smoothScrollTo(targetElement) {
  gsap.to(window, {
    duration: 1, // スクロールの時間 (秒)
    ease: "power4.out", // イージングの種類
    scrollTo: {
      y: targetElement, // スクロール先のターゲット要素
      offsetY: document.querySelector('.l-header').offsetHeight + 70 || 0, // ヘッダー高さ分オフセット
    },
  });
}


// 追従ボタン
// =======================================================

const fixedBtn = document.querySelector('.c-btnbox__fixed');
const footer = document.querySelector('.l-footer'); // フッターの要素を取得

if (fixedBtn && footer) {
  ScrollTrigger.create({
    trigger: document.body,
    start: "top top+=-50%",          // 画面の半分で is-show 付与
    endTrigger: "footer",         // ← ここ重要！
    end: "top bottom",            // footer の top が画面下に入ったら終了判定
    onEnter: () => fixedBtn.classList.add("is-show"),
    onEnterBack: () => fixedBtn.classList.add("is-show"),
    onLeave: () => fixedBtn.classList.remove("is-show"),      // end に達したとき
    onLeaveBack: () => fixedBtn.classList.remove("is-show"),  // 戻ったとき
  });
}

const floatBtn = document.querySelector('.c-btn__float');

if (floatBtn && footer) {
  ScrollTrigger.create({
    trigger: document.body,
    start: "top top+=-50%",          // 画面の半分で is-show 付与
    endTrigger: "footer",         // ← ここ重要！
    end: "top bottom",            // footer の top が画面下に入ったら終了判定
    onEnter: () => floatBtn.classList.add("is-show"),
    onEnterBack: () => floatBtn.classList.add("is-show"),
    onLeave: () => floatBtn.classList.remove("is-show"),      // end に達したとき
    onLeaveBack: () => floatBtn.classList.remove("is-show"),  // 戻ったとき
  });
}



// Custom Select Box
// =======================================================

document.addEventListener("DOMContentLoaded", function() {
  const customSelects = document.querySelectorAll("[data-custom-select]");
  customSelects.forEach(select => {
    new TomSelect(select, {
      create: false,                  // 新しいオプションの追加を無効化
      controlInput: false,            // 検索用の入力を無効化
      allowEmptyOption: true,         // 空のオプションをプレースホルダーとして認識
      placeholder: '選択してください'   // プレースホルダーを設定
    });
  });
});